import { FC, JSX, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { Slide } from '@player/content';

import { toast } from '@/shared/lib/toastManager';
import Button from '@/shared/ui/button';
import PlusIcon from '@/shared/ui/icons/Plus';

import DeleteModal from '../DeleteModal';

import { SlideTile } from './SlideTile';

export interface IListProps {}

export const List: FC<IListProps> = (): JSX.Element => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [slideToDelete, setSlideToDelete] = useState<number>(-1);

  const {
    fields: slides,
    append,
    remove,
  } = useFieldArray({
    name: 'slides',
  });

  const addNewSlideHandler = () => {
    const newSlide: Slide = {
      image: '',
      title: '',
      link: '',
    };

    append(newSlide);
  };

  const onRemoveClickHandler = (index: number) => {
    setSlideToDelete(index);
    setShowDeleteModal(true);
  };

  const onDeleteHandler = () => {
    setShowDeleteModal(false);
    remove(slideToDelete);
    toast('Card removed', 'deleteCard');
    setSlideToDelete(-1);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-4">
        {slides.map((slide, index) => (
          <SlideTile
            // I believe we can avoid this manual id generation in next version:
            // https://github.com/react-hook-form/react-hook-form/releases/tag/v8.0.0-beta.1
            key={slide.id || index}
            index={index}
            onRemoveClick={() => {
              // shouldn't delete last one
              if (slides.length === 1) return;

              onRemoveClickHandler(index);
            }}
          />
        ))}

        <Button
          onClick={addNewSlideHandler}
          variant="primary"
          size="sm"
          title="Add content"
          iconAfter={<PlusIcon />}
          className="h-[298px] w-[312px] border border-dashed border-blue/[.12] bg-blue/[.02] !text-blue hover:!text-white"
        />
      </div>

      {showDeleteModal && (
        <DeleteModal
          onClose={() => setShowDeleteModal(false)}
          onDelete={onDeleteHandler}
        />
      )}
    </div>
  );
};

export default List;
